import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Testimonials, StatsBar } from '../components/home/HomeComponents';
import aboutImg from '../assets/aboutpage.jpeg';
function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth < breakpoint : false
  );
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, [breakpoint]);
  return isMobile;
}

export default function AboutPage() {
  const isMobile = useIsMobile();

  return (
    <div style={{ paddingTop: 64, minHeight: '100vh' }}>

      {/* ── Hero — stacks vertically on mobile ── */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
        height: isMobile ? 'auto' : 'calc(100vh - 64px)',
      }}>

        {/* Image block */}
        <div style={{
          position: 'relative',
          overflow: 'hidden',
          background: '#ede9e3',
          height: isMobile ? 320 : '100%',
          minHeight: isMobile ? 'unset' : 0,
        }}>
          <img
            src={aboutImg}
            alt="Aurora Luxury India — Authenticated Luxury"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center',
              display: 'block',
            }}
          />

  {/* Dark overlay for readability */}
  <div style={{
    position: 'absolute',
    inset: 0,
    background: 'linear-gradient(to top, rgba(0,0,0,0.45) 0%, rgba(0,0,0,0.05) 60%)',
  }} />

  {/* Est. badge */}
  <div style={{
    position: 'absolute', bottom: isMobile ? 16 : 32, left: isMobile ? 20 : 32,
    fontSize: 10, letterSpacing: '0.28em', textTransform: 'uppercase',
    color: 'rgba(255,255,255,0.75)', fontWeight: 600, fontFamily: 'var(--font-body)',
  }}>
    Est. 2020 — Mumbai, India
  </div>
</div>

        {/* Content block */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          padding: isMobile
            ? '40px 20px 48px'
            : 'clamp(48px, 8vw, 100px) clamp(40px, 6vw, 80px)',
          background: 'var(--cream)',
        }}>

          <div style={{
            fontSize: 10, letterSpacing: '0.28em', textTransform: 'uppercase',
            color: 'var(--gold)', fontWeight: 600, fontFamily: 'var(--font-body)',
            marginBottom: 20,
          }}>
            The Heritage
          </div>

          <h1 style={{
            fontFamily: 'var(--font-display)',
            fontSize: isMobile ? 'clamp(28px, 7vw, 40px)' : 'clamp(32px, 4.5vw, 58px)',
            fontWeight: 300, color: 'var(--dark)',
            letterSpacing: '-0.02em', lineHeight: 1.1,
            margin: '0 0 24px',
          }}>
            India's Private Gateway<br />to World Luxury
          </h1>

          <p style={{
            fontSize: 13, color: 'var(--grey-dark)', lineHeight: 1.85,
            fontWeight: 300, fontFamily: 'var(--font-body)',
            maxWidth: 440, margin: '0 0 16px',
          }}>
            We established Aurora Luxury with a singular vision — to bridge the gap between
            India's discerning clientele and the world's most coveted fashion houses.
          </p>

          <p style={{
            fontSize: 13, color: 'var(--grey-dark)', lineHeight: 1.85,
            fontWeight: 300, fontFamily: 'var(--font-body)',
            maxWidth: 440, margin: '0 0 16px',
          }}>
            Every piece in our curation is personally sourced from flagship boutiques across
            Paris, Milan, and London. We pride ourselves on complete transparency, providing
            original documentation and pristine boutique packaging with every acquisition.
          </p>

          <p style={{
            fontSize: 13, color: 'var(--grey-dark)', lineHeight: 1.85,
            fontWeight: 300, fontFamily: 'var(--font-body)',
            maxWidth: 440, margin: '0 0 36px',
          }}>
            Beyond commerce, we offer a dedicated concierge service, hunting down rare,
            sold-out, and waitlisted pieces specifically for our private clients.
          </p>

          {/* Stats row */}
          <div style={{ display: 'flex', gap: isMobile ? 32 : 48 }}>
            {[['100%', 'Authenticity'], ['48hr', 'Dispatch']].map(([num, label]) => (
              <div key={label}>
                <div style={{
                  fontFamily: 'var(--font-display)',
                  fontSize: isMobile ? 'clamp(22px, 6vw, 32px)' : 'clamp(24px, 3vw, 36px)',
                  fontWeight: 300, color: 'var(--dark)', lineHeight: 1,
                }}>
                  {num}
                </div>
                <div style={{
                  fontSize: 9, letterSpacing: '0.22em', textTransform: 'uppercase',
                  color: 'var(--grey-mid)', fontWeight: 600,
                  fontFamily: 'var(--font-body)', marginTop: 6,
                }}>
                  {label}
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>

      {/* ── Spacer section (kept for structure) ── */}
      <div style={{ maxWidth: 760, margin: '0 auto', padding: isMobile ? '0' : '72px 24px' }} />

      <Testimonials />
      <StatsBar />

    </div>
  );
}